let musickitInstance = null;

const MUSICKIT_SRC = 'https://js-cdn.music.apple.com/musickit/v3/musickit.js';

function loadMusicKit() {
      return new Promise((resolve, reject) => {
            if (window.MusicKit) return resolve(window.MusicKit);
            const existing = document.querySelector('script[data-mieros-musickit]');
            if (existing) {
                  existing.addEventListener('load', () => {
                        if (window.MusicKit) resolve(window.MusicKit);
                        else reject(new Error('MusicKit failed to initialize'));
                  });
                  existing.addEventListener('error', reject);
                  return;
            }
            const script = document.createElement('script');
            script.src = MUSICKIT_SRC;
            script.async = true;
            script.defer = true;
            script.setAttribute('data-mieros-musickit', 'true');
            script.onload = () => {
                  if (window.MusicKit) resolve(window.MusicKit);
                  else reject(new Error('MusicKit failed to initialize'));
            };
            script.onerror = reject;
            document.head.appendChild(script);
      });
}

export const initializeMusicKit = async (developerToken) => {
      if (musickitInstance) return musickitInstance;
      const MusicKit = await loadMusicKit();
      musickitInstance = MusicKit.configure({
            developerToken,
            app: { name: 'MiEROS', build: '1.0.0' },
      });
      return musickitInstance;
};

export const getMusicKitInstance = () => musickitInstance;
